import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Card } from '../ui/Card';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { Checkbox } from '../ui/Checkbox';
import { Trainee } from '../../types';
interface Step4Props {
  selectedTrainees: string[];
  onChange: (trainees: string[]) => void;
}
export function Step4Trainees({
  selectedTrainees,
  onChange
}: Step4Props) {
  const [filters, setFilters] = useState({
    division: '',
    district: '',
    upazilla: '',
    union: ''
  });
  const [trainees, setTrainees] = useState<Trainee[]>([]);
  const [hasSearched, setHasSearched] = useState(false);
  const divisions = [{
    value: 'dhaka',
    label: 'Dhaka'
  }, {
    value: 'chittagong',
    label: 'Chittagong'
  }, {
    value: 'rajshahi',
    label: 'Rajshahi'
  }];
  const districts = [{
    value: 'dhaka-city',
    label: 'Dhaka City'
  }, {
    value: 'gazipur',
    label: 'Gazipur'
  }];
  const upazillas = [{
    value: 'mirpur',
    label: 'Mirpur'
  }, {
    value: 'uttara',
    label: 'Uttara'
  }];
  const unions = [{
    value: 'union-1',
    label: 'Union 1'
  }, {
    value: 'union-2',
    label: 'Union 2'
  }];
  const handleSearch = () => {
    // Simulate API call
    const mockTrainees: Trainee[] = [{
      id: '1',
      name: 'Karim Ahmed',
      phone: '01712345678',
      email: 'karim@example.com',
      gender: 'Male',
      division: filters.division,
      district: filters.district,
      upazilla: filters.upazilla,
      union: filters.union
    }, {
      id: '2',
      name: 'Fatima Rahman',
      phone: '01812345678',
      email: 'fatima@example.com',
      gender: 'Female',
      division: filters.division,
      district: filters.district,
      upazilla: filters.upazilla,
      union: filters.union
    }, {
      id: '3',
      name: 'Abdul Haque',
      phone: '01912345678',
      email: 'abdul@example.com',
      gender: 'Male',
      division: filters.division,
      district: filters.district,
      upazilla: filters.upazilla,
      union: filters.union
    }];
    setTrainees(mockTrainees);
    setHasSearched(true);
  };
  const handleClearFilters = () => {
    setFilters({
      division: '',
      district: '',
      upazilla: '',
      union: ''
    });
    setTrainees([]);
    setHasSearched(false);
  };
  const toggleTrainee = (id: string) => {
    if (selectedTrainees.includes(id)) {
      onChange(selectedTrainees.filter(t => t !== id));
    } else {
      onChange([...selectedTrainees, id]);
    }
  };
  const toggleAll = () => {
    if (selectedTrainees.length === trainees.length) {
      onChange([]);
    } else {
      onChange(trainees.map(t => t.id));
    }
  };
  return <Card title="Add Trainees / Participants" data-id="element-91">
      <div className="space-y-6" data-id="element-92">
        <div className="grid grid-cols-4 gap-4" data-id="element-93">
          <Select label="Division" value={filters.division} onChange={e => setFilters({
          ...filters,
          division: e.target.value
        })} options={divisions} data-id="element-94" />
          <Select label="District" value={filters.district} onChange={e => setFilters({
          ...filters,
          district: e.target.value
        })} options={districts} data-id="element-95" />
          <Select label="Upazilla" value={filters.upazilla} onChange={e => setFilters({
          ...filters,
          upazilla: e.target.value
        })} options={upazillas} data-id="element-96" />
          <Select label="Union" value={filters.union} onChange={e => setFilters({
          ...filters,
          union: e.target.value
        })} options={unions} data-id="element-97" />
        </div>

        <div className="flex gap-3" data-id="element-98">
          <Button onClick={handleSearch} data-id="element-99">
            <Search className="w-4 h-4 mr-2" data-id="element-100" />
            Apply Filter
          </Button>
          <Button variant="secondary" onClick={handleClearFilters} data-id="element-101">
            Clear Filters
          </Button>
        </div>

        {selectedTrainees.length > 0 && <div className="bg-blue-50 border border-blue-200 rounded-lg p-3" data-id="element-102">
            <p className="text-sm text-blue-900" data-id="element-103">
              <strong data-id="element-104">Selected Participants:</strong> {selectedTrainees.length}
            </p>
          </div>}

        {!hasSearched ? <div className="text-center py-12 text-gray-500" data-id="element-105">
            Select filters and click "Apply Filter" to load trainees
          </div> : trainees.length === 0 ? <div className="text-center py-12 text-gray-500" data-id="element-106">
            No trainees found matching the selected filters
          </div> : <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-107">
            <table className="w-full" data-id="element-108">
              <thead className="bg-gray-50 border-b border-gray-200" data-id="element-109">
                <tr data-id="element-110">
                  <th className="px-4 py-3 text-left" data-id="element-111">
                    <Checkbox checked={selectedTrainees.length === trainees.length} onChange={toggleAll} data-id="element-112" />
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-113">
                    SL
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-114">
                    Name
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-115">
                    Phone
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-116">
                    Email
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-117">
                    Gender
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-118">
                    Location
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-119">
                {trainees.map((trainee, index) => <tr key={trainee.id} className="hover:bg-gray-50" data-id="element-120">
                    <td className="px-4 py-3" data-id="element-121">
                      <Checkbox checked={selectedTrainees.includes(trainee.id)} onChange={() => toggleTrainee(trainee.id)} data-id="element-122" />
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-123">
                      {index + 1}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-124">
                      {trainee.name}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-125">
                      {trainee.phone}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-126">
                      {trainee.email}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-127">
                      {trainee.gender}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-128">
                      {trainee.division}, {trainee.district}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
    </Card>;
}